import AppRoutes from './AppRoutes';
import { AuthProvider } from './context/AuthContext';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Modal from 'react-modal';                                                                
Modal.setAppElement('#root');

function App() {
  return (
    <AuthProvider>
      <>
        <AppRoutes />
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="dark" // or "light" based on your UI preference
        />
      </>
    </AuthProvider>
  );
}

export default App;
